import React from "react";

interface SwitchProps extends React.InputHTMLAttributes<HTMLInputElement> {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  label?: string;
  className?:string
}

const Switch: React.FC<SwitchProps> = ({
  checked,
  onCheckedChange,
  disabled = false,
  label,
  className,
  ...rest
}) => {
  return (
    <label
      className={`inline-flex items-center cursor-pointer select-none my-2 ${className} ${
        disabled ? "opacity-50 cursor-not-allowed" : ""
      }`}
    >
      <input
        type="checkbox"
        className="sr-only"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onCheckedChange(e.target.checked)}
        {...rest}
      />

      <span
        className={`w-11 h-6 rounded-full relative transition-colors  duration-200
          ${checked ? "bg-primary" : "bg-gray-300"}
          ${disabled ? "opacity-50" : ""}
        `}
        aria-hidden="true"
      >
        <span
          className={`block w-5 h-5 mt-0.5 bg-white rounded-full shadow transform transition-transform duration-200 ease-in-out
            ${checked ? "translate-x-5" : "translate-x-1"}
          `}
        />
        
      </span>
      {label && <span className="ml-3 select-none text-bodyText">{label}</span>}
    </label>
  );
};

export default Switch;
